import React from 'react';
import AppLoaded from '../../components/app-loaded';
import Page from '../../components/page';
import { FullHeightLayout, SimpleLayout } from '../../components/layout';
import AccountSuspended from '../../components/account-suspended';
import forDevice from '../../hoc/for-device';

const Layout = forDevice(FullHeightLayout, SimpleLayout);

const AccountSuspendedPage = () =>
  <Page>
    <Layout>
      <AccountSuspended/>
    </Layout>
    <AppLoaded/>
  </Page>;

export default AccountSuspendedPage;



// WEBPACK FOOTER //
// ./app/containers/account-suspended-page/account-suspended-page.js